import React from 'react';
import './ImageTextBlock.css';

interface ImageTextBlockProps {
  imageSrc: string;
  imageAlt?: string;
  title?: string;
  text: React.ReactNode;
  reverse?: boolean; // If true, image is on the right
  buttonText?: string;
  buttonLink?: string;
}

const ImageTextBlock: React.FC<ImageTextBlockProps> = ({
  imageSrc,
  imageAlt = '',
  title,
  text,
  reverse = false,
  buttonText,
  buttonLink,
}) => (
  <div className={`image-text-block${reverse ? ' reverse' : ''}`}>
    <div className="image-text-block-image">
      <img src={imageSrc} alt={imageAlt} />
    </div>
    <div className="image-text-block-content">
      {title && <h3>{title}</h3>}
      <div>{text}</div>
      {buttonText && buttonLink && (
        <a className="itb-button" href={buttonLink}>
          {buttonText}
        </a>
      )}
    </div>
  </div>
);

export default ImageTextBlock;